import { Injectable, inject } from '@angular/core';
import { InterpolationFragment, InterpolationFragmentType } from '../../models';
import {
    IInterpolationFragmentService,
    TokenParts,
} from './interpolation-fragment.service.interface';

@Injectable({
    providedIn: 'root',
})
export class InterpolationDisplayService {
    readonly NOTIFICATION_FRAGMENT_TYPE = InterpolationFragmentType;
    private fragmentService = inject(IInterpolationFragmentService);

    oldParseInterpolation(
        value: string,
        entityId: string,
    ): Array<InterpolationFragment> {
        return (
            value
                // split entire string (e.g. 'abc#I:II:III#def#1:2:3#...) by the pattern #a:b:c#
                ?.split(/#(.*?)#/gi)
                // remove empty ones
                .filter((fragment) => fragment)
                .map((fragment: string): InterpolationFragment => {
                    // further split fragments to a and b and c
                    const [token, name, id, type] = this.execRegExp(
                        fragment,
                    ) || [fragment];
                    const parts: TokenParts = { token, name, id, type };

                    return this.fragmentService.convertTokenPartsToFragment(
                        parts,
                        entityId,
                    );
                })
        );
    }

    parseInterpolation(
        value: string,
        entityId: string,
        regarding?: string,
    ): Array<InterpolationFragment> {
        return value
            ?.split(/\[(.*?)\]/)
            .filter((fragment) => fragment)
            .map((fragment: string): InterpolationFragment => {
                // further split fragments to a and b and c
                const parts: TokenParts = this.createTokenParts(fragment);
                const regardingParts = this.createTokenParts(regarding ?? '');
                return this.fragmentService.convertTokenPartsToFragment(
                    parts,
                    entityId,
                    regardingParts,
                );
            });
    }

    private createTokenParts(fragment: string) {
        const [token, type, id, name] =
            // eslint-disable-next-line no-useless-escape
            /(?<type>[^\[\|]+)\|(?<id>[^\[\|]+)\|(?<name>[^\]\|]*)?/.exec(
                fragment,
            ) || [fragment];
        const parts: TokenParts = {
            token,
            name: decodeURIComponent(name || ''),
            id,
            type,
        };
        return parts;
    }

    private execRegExp(value: string): RegExpExecArray | null {
        return new RegExp(
            '(?<title>[^#:]+):(?<id>[^#:]+):(?<type>[^#:]+)',
        ).exec(value);
    }
}
